import { FaAngleDown, FaAngleUp } from "react-icons/fa";

import ExpandOnHover from "./shared/ExpandOnHover";
import { useState } from "react";

export default function Accordion({
    title,
    books,
    courses,
    youtubeLinks,
    others,
}) {
    const [isActive, setisActive] = useState(false);

    // const booksList = JSON.parse(books);

    const handleToggle = () => {
        setisActive(!isActive);
    };

    return (
        <ExpandOnHover noBrighten={true}>
            <div className="card my-4">
                <div className="card-content">
                    <div className="content">
                        <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <div className="content">
                                        <h1 className="title">{title}</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    <button
                                        onClick={handleToggle}
                                        className="button is-light"
                                    >
                                        {isActive ? (
                                            <FaAngleUp />
                                        ) : (
                                            <FaAngleDown />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {isActive && (
                            <div className="content">
                                {books ? (
                                    <>
                                        <p className="subtitle">Books</p>
                                        <ul>
                                            {books.map((book) => (
                                                <li key={book.name}>
                                                    {/* {book.substring(0, 33) +
                                                        "..."} */}
                                                    {book.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ) : null}
                                {courses ? (
                                    <>
                                        <p className="subtitle">courses</p>
                                        <ul>
                                            {courses.map((course) => (
                                                <li key={course.name}>
                                                    {/* {course.substring(0, 33) +
                                                        "..."} */}
                                                    <a
                                                        href={course.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {course.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ) : null}
                                {youtubeLinks && (
                                    <>
                                        <p className="subtitle">
                                            Youtube Links
                                        </p>
                                        <ul>
                                            {youtubeLinks.map((youtubeLink) => (
                                                <li key={youtubeLink.link}>
                                                    <a
                                                        href={youtubeLink.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {youtubeLink.link}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}

                                {others && (
                                    <>
                                        <p className="subtitle">Other Links</p>
                                        <ul>
                                            {others.map((other) => (
                                                <li key={other.name}>
                                                    <a
                                                        href={other.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {other.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ExpandOnHover>
    );
}
